import { Link } from 'react-router-dom';
import { Star, MessageSquare } from 'lucide-react';

const CompanyCard = ({ company, rank, sortOrder }) => {
  const getRankColor = (r, order) => {
    if (order === 'asc') {
      if (r >= 0 && r <= 3)
        return 'bg-red-200 dark:bg-red-800 text-red-800 dark:text-red-100';
      else
        return 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200';
    }
    if (r === 1) return 'bg-yellow-400 text-yellow-900';
    if (r === 2) return 'bg-gray-300 dark:bg-gray-500 text-gray-800 dark:text-gray-100';
    if (r === 3) return 'bg-yellow-600/70 text-white';
    return 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200';
  };
  return (
    <Link to={`/company/${encodeURIComponent(company.companyName)}`} className="bg-gray-50 dark:bg-gray-800/50 border dark:border-gray-700 p-4 rounded-lg hover:shadow-md hover:border-blue-400 dark:hover:border-blue-500 cursor-pointer flex items-center space-x-4">
      {rank && <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${getRankColor(rank, sortOrder)}`}>{rank}</div>}
      <div className="flex-grow">
        <h3 className="text-xl font-bold">{company.companyName}</h3>
        {/* <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{company.summary}</p> */}
      </div>
      <div className="flex items-center space-x-4 pl-4">
        <div className="flex items-center space-x-1 text-yellow-500">
          <Star /><span className="font-bold text-lg">{company.rating}</span>
        </div>
        <div className="flex items-center space-x-1 text-gray-500 dark:text-gray-400">
          <MessageSquare />
          <span className="font-bold text-lg">{company.reportCount}</span>
        </div>
      </div>
    </Link>
  );
};

export default CompanyCard;